<template>
  <div>
    <div class="container-fluid">
      <button
        type="button"
        style="top:90px;right:20px;z-index:20"
        @click="backToIndex"
        class="position-absolute btn btn-default m-0"
      >回上一頁</button>
      <div
        class="mb-3"
        :class="{'section-loading': infoLoading}"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75 pr-4">
          <h4 class="mb-line title text-green mt-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <i
              v-if="categoryInfo.upload_file ===''"
              class="icon-attach text-orange ml-2"
            ></i>
            <span
              style="font-size: medium;color: black;"
            >{{ categoryInfo.upload_file | removeExten }}</span>
          </h4>
          <div class="mb-line" style>
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class="mb-line">
            <span class="mr-2">{{ categoryInfo.description }}</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div class="mb-line" :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': notificationsLoading}">
      <div class="row">
        <section class="newTable">
          <table class="table datatable table-striped area-list-datatable">
            <thead>
              <tr style="padding-right: 17px;">
                <th :width="screenWidth * 0.10">
                  <div class="checkbox checkbox-inline mr-0">
                    <input
                      type="checkbox"
                      :name="`substantial-check-all`"
                      :id="`substantial-check-all`"
                      v-model="checkAll"
                      @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                    />
                    <label :for="`substantial-check-all`"></label>
                  </div>
                  <span>#</span>
                </th>
                <th
                  :width="screenWidth * 0.08"
                  class="sorting"
                  :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting('name')"
                >姓名</th>
                <th
                  :width="screenWidth * 0.086"
                  class="sorting"
                  :class="'sorting ' + (order.fieldName == 'insured' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting('insured')"
                >被保人</th>
                <th
                  :width="screenWidth * 0.09"
                  class="sorting"
                  :class="'sorting ' + (order.fieldName == 'insuranceId' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting('insuranceId')"
                >保單號碼</th>
                <th
                  :width="screenWidth * 0.12"
                  class="sorting"
                  :class="'sorting ' + (order.fieldName == 'insurancetype' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting('insurancetype')"
                >險別名稱</th>
                <th :width="screenWidth * 0.08">投保始期</th>
                <th
                  :width="screenWidth * 0.09"
                  class="sorting"
                  :class="'sorting ' + (order.fieldName == 'endDate' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting('endDate')"
                >可辦理加入集彙件終期</th>
                <th :width="screenWidth * 0.09">排訪</th>
              </tr>
            </thead>
            <tbody :style="{ height: scrollHeight + 'px' }">
              <tr v-for="(item, index) in tableDataBackup" :key="`out-${index}`">
                <td :width="screenWidth * 0.10">
                  <div style="min-height: 30px;">
                    <div class="mr-0 checkbox checkbox-inline">
                      <input
                        @click="clickTarget = clickTarget == `td-${index}`? `td-${index}-again`: `td-${index}`"
                        type="checkbox"
                        name="`td-item[]`"
                        :id="`check-out-${index}`"
                        :value="item.custNo"
                        v-model="selection"
                        :disabled="item.custNo === ''"
                        @change="$emit('update', selection)"
                      />
                      <label :for="`check-out-${index}`"></label>
                    </div>
                    <span>
                      <span class="no">{{ item.custNo}}</span>
                      <span class="info text-center">
                        <level :lv="Number(item.vip_level)" />
                        <avatar :gender="Number(item.sex)" :size="20" />
                      </span>
                    </span>
                  </div>
                </td>
                <td
                  :width="screenWidth * 0.08"
                  @click="toCustDetail({custId: item.custNo})"
                  class="link text-underline"
                >{{ item.name }}</td>
                <td :width="screenWidth * 0.086">{{item.insured}}</td>
                <td :width="screenWidth * 0.09">{{ item.insuranceId }}</td>
                <td :width="screenWidth * 0.12">{{ item.insurancetype }}</td>
                <td :width="screenWidth * 0.08">{{ item.startDate | dateFormat }}</td>
                <td :width="screenWidth * 0.09">{{ item.endDate | dateFormat}}</td>
                <td :width="screenWidth * 0.09">
                  <button
                    v-if="item.scheduleDate!==''"
                    class="btn btn-primary m-0 twoLine"
                  >{{item.scheduleDate}}</button>
                  <button v-else class="btn btn-primary m-0">預約</button>
                </td>
              </tr>
              <tr v-if="tableDataBackup.length == 0">
                <td colspan="8" class="text-center pt-3 pb-5">
                  <h3>無客戶名單資料</h3>
                </td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
                <td style="display: none;"></td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-md-12 d-flex justify-content-end mb-2">
          <button
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            class="btn btn-primary"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal :open="printModalOpen" :custs="selection" @close="panelClose('printModalOpen')" />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import SendModal from "../SendModal";
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import SatisfactionModal from "../SatisfactionModal";
import {
  getCategoryDetail,
  isSatisfactionSurveyFinish,
  getHandleGroupRemittanceNotification
} from "@/service";
import $ from "jquery";

export default {
  name: "HandleGroupRemittanceNotification",
  mixins: [commonMixin],
  components: {
    SendModal,
    Level,
    Avatar,
    PrintModal,
    GroupModal,
    SatisfactionModal
  },
  watch: {
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach(data => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  props: {
    status: String
  },
  filters: {},
  data() {
    //data block layout
    return {
      notificationsLoading: false,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      isBtnEnble: true,
      isLoading_btn: false,
      categoryInfo: {},
      tableData: [],
      tableDataBackup: [],
      allIdData: [],
      clickTarget: "",
      checkAllClick: false,
      checkAll: false,
      selection: [],
      message: "",
      title: "",
      screenWidth:
        document.body.clientWidth > 1208 ? 1280 : document.body.clientWidth,
      scrollHeight: 0,
      order: {
        fieldName: "custNo",
        asc: true
      },

      satisfactionModalOpen: false
    };
  },
  methods: {
    ...mapActions([
      "setPageLock",
      "updateCustInfo",
      "updateCustID",
      "updateSerNo"
    ]),
    initCustList() {
      // 初始化
      this.notificationsLoading = true;
      this.checkAll = false;
      this.selection = [];
      getHandleGroupRemittanceNotification(this.$store.state.userInfo.id).then(
        result => {
          console.log(result);
          // 取得客戶列表
          this.notificationsLoading = false;
          if (result && result.header.status == "200" && result.body) {
            this.tableData = result.body.notification_list;
            this.tableDataBackup = this.tableData.map(ele => {
              return ele;
            });
            this.allIdData = this.tableData.map(ele => {
              return ele.custNo;
            });
            this.order.fieldName = "name";
            this.order.asc = true;
            this.registerHanlink(); // for hard word
          }
        }
      );

      // 取得專區資訊
      this.getTitleInfo();

      // 確認滿意度
      this.checkIsSatisfactionSurveyFinish();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status == "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    columnSorting(fieldName) {
      console.log(`>>>>> columnSorting:${fieldName} <<<<<`);
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        console.log("change sort field");
        this.order.fieldName = fieldName;
        this.order.asc = true;
        console.log(this.order);
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "cenxpdt":
        case "last_visitday":
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.dateCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    dateCompareFun(sortOrder, property) {
      let vm = this;
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.isBtnEnble = result.body.isfinish == "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    submitGroup(group) {
      // 加入群組導頁至 群組列表
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    formatMark(str) {
      // filter 客戶標記
      let idmark = [];

      if (str.includes("G")) {
        idmark.push("黃金VIP");
      }
      if (str.includes("P")) {
        idmark.push("白金VIP");
      }
      if (str.includes("D")) {
        idmark.push("鑽石VIP");
      }
      if (str.includes("S")) {
        idmark.push("密戶");
      }

      return idmark.join(",");
    },
    updateSelection(val) {
      this.selection = val;
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_SERVICE_RIGHT_LIST");
    },
    toCustDetail({ custId = "", serNo = "" }) {
      // 導頁至客戶資料
      if (custId !== "") {
        this.updateCustID(custId);
        this.updateSerNo("");
        localStorage.CustID = custId;
        localStorage.SerNo = "";
        this.$router.push({ path: `/detail/CustID/tab/1` });
      } else {
        this.updateSerNo(serNo);
        this.updateCustID("");
        localStorage.CustID = "";
        localStorage.SerNo = serNo;
        this.$router.push({ path: `/detail/SerNo/tab/1` });
      }
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_SERVICE_RIGHT_LIST");
    }
  },
  mounted() {
    // 初始化頁面
    this.initCustList();

    // 監聽視窗寬度
    const self = this;

    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth > 1220) {
          window.screenWidth = 1220;
          self.screenWidth = 1220;
        } else {
          window.screenWidth = document.body.clientWidth;
          self.screenWidth = window.screenWidth;
        }
      })();
    };

    this.scrollHeight =
      parseInt($(window).height()) - $("tbody").offset().top - 85;
    $(window).bind("orientationchange", function(event) {
      self.scrollHeight =
        parseInt($(window).height()) - $("tbody").offset().top - 85;
    });
    $(".tab-content").css("padding-bottom", "62px");
  }
};
</script>

<style lang="scss" scoped>
.mb-line .btn.btn-default {
  width: 140px;
  padding: 2px 0;
}
.newTable thead {
  tr {
    padding-right: 17px;
    display: table;
    width: calc(100% - 17px);
    table-layout: fixed;
  }

  th:last-of-type {
    border-width: 0;
  }
}

.newTable tbody {
  display: block;
  // height: 552px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  td {
    .btn.btn-primary {
      height: 40px;
      width: 100%;
      &.twoLine {
        padding: 4px 28px;
        font-size: 13px;
        line-height: 16px;
      }
    }

    border-bottom-width: 0 !important;
  }

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>